// import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { environment } from 'src/environments/environment';
// import { Injectable } from '@angular/core';
// import { GenericApi } from './shared/generic.api';
// import { ApiUrls } from 'src/app/config/constants';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { GenericApi } from './shared/generic.api';
import { ApiUrls } from 'src/app/config/constants';

@Injectable()
export class CommonApi extends GenericApi {



  apiUrl = {
    categories: `${environment.baseUrl}`,
    //allLanguages: `http://43.205.9.141:1205/apis/v1/households/splash`,
    saveShops: (retailerId) =>
      `http://43.205.9.141:1205/apis/v1/retailers/${retailerId}/shops`,

    addCatalog: (shopid) =>
      `${environment.baseUrl}/rms/apis/v1/catalog/:${shopid}`,

    addShop: `${environment.baseUrl}/rms/apis/v1/shop`,
    addShopTime: `${environment.baseUrl}/rms/apis/v1/time/`,

    getUploadAadhar: `${environment.baseUrl}/onbs/apis/v1/onboarding/retailer/kyc/aadhar`,
    getUploadPan: `${environment.baseUrl}/onbs/apis/v1/onboarding/retailer/kyc/pan`,
    addKYC: `${environment.baseUrl}/onbs/apis/v1/onboarding/retailer/kyc`,

    //getBankURLDOC: `${environment.baseUrl}/onbs/apis/v1/onboarding/retailer/bank/uploadfile`,
    //addBank: `${environment.baseUrl}/onbs/apis/v1/onboarding/retailer/bank`,

    /* Subscription - Razorpay */
    //createSubscription: `${environment.baseUrl}/sub/apis/v1/subscription/initiate`,
    //confirmSubscription: `${environment.baseUrl}/sub/apis/v1/subscription/activate`,

    //getAllSubscription: `${environment.baseUrl}/sub/apis/v1/subscription/`,
  };

  private headers = new HttpHeaders({
    skip: 'true',
  });

  private skipHttpCall = {
    headers: this.headers
  };

  private invalidateHeaders = new HttpHeaders({
    cacheInvalidate: 'true',
    skip: 'true',
    'Cache-Control': 'no-cache',
  });

  private invalidateHttpCallCache = { headers: this.invalidateHeaders };


  constructor(http: HttpClient) {
    super(http);
  }

  /**
   * @name getCategories
   * @type Value-returning function - Call APi to get All retialer products
   * @param categoriesData - contains limit, offset, and city
   **/

  /*
   --- For Example ---
  getCategories(categoriesData) {
    return this.get(
      `${this.apiUrl.categories}?limit=${categoriesData.limit}&offset=${categoriesData.offset}&city=${categoriesData.city}`
    );
  }
  */

  /**
   * @name getDataByUrl
   * @type Value-returning function - Call APi to get Data by URL
   **/
  getDataByUrl(url: any) {
    return this.get(url);
  }

  getAllLanguage() {
    return this.get(environment.baseUrl + ApiUrls.splash);
  }

  getCDNLink(selectUrl: any) {
    return this.get(`${selectUrl}`, this.skipHttpCall);
  }

  getCDNLinkNoCache(selectUrl: any) {
    return this.get(`${selectUrl}`, this.invalidateHttpCallCache);
  }

  getStoreDetails(id: any) {
    return this.get(`${ApiUrls.sellerProfile + id}`, this.skipHttpCall)
  }

  getData(url: string, options?: { params?: any }) {
    return this.get(environment.baseUrl + url, options);
  }

  postData(url: any, data: any) {
    return this.post(environment.baseUrl + url, data);
  }

  putData(url: any, data: any) {
    return this.put(environment.baseUrl + url, data);
  }

  addShopWorkingTime(shopid: any, body: any) {
    return this.post(`${this.apiUrl.addShopTime}/${shopid}`, body);
  }

  updateShopStatus(shopId: string, shopStatus: any) {
    return this.put(`${environment.baseUrl + ApiUrls.updateShopStatus}/${shopId}`, shopStatus)
  }

  getUploadKYCURL(docType: any) {
    if (docType == 'aadhar') {
      return this.get(`${this.apiUrl.getUploadAadhar}`);
    } else {
      return this.get(`${this.apiUrl.getUploadPan}`);
    }
  }

  addKYCDetails(body: any) {
    return this.post(`${this.apiUrl.addKYC}`, body);
  }

  getKYCDetails() {
    return this.get(`${environment.baseUrl + ApiUrls.getKycDetails}`);
  }

  getBankPassbookLink() {
    return this.get(`${environment.baseUrl + ApiUrls.getBankURLDOC}`);
  }

  addBankDetails(body: any) {
    return this.post(`${environment.baseUrl + ApiUrls.addBank}`, body);
  }

  /* Subscription - Razorpay*/
  createSubscription(body: any) {
    return this.post(`${environment.baseUrl + ApiUrls.createSubscription}`, body);
  }

  confirmSubscription(body: any) {
    return this.post(`${environment.baseUrl + ApiUrls.confirmSubscription}`, body);
  }

  getAllSubscription(subscripId: any) {
    return this.get(`${environment.baseUrl + ApiUrls.getAllSubscription}${subscripId}`);
  }

  checkStatusSubscription(subscripId: any) {
    return this.get(`${environment.baseUrl + ApiUrls.checkStatus}${subscripId}`);
  }

  deleteData(url: any) {
    return this.delete(environment.baseUrl + url);
  }

  deleteAccount(url: any, payload: any) {
    return this.delete(environment.baseUrl + url, payload);
  }

  putRatingData(url: any, payload: any) {
    return this.post(environment.baseUrl + url, payload);
  }

  patchData(url: any, number?: any) {
    return this.patch(environment.baseUrl + url, number);
  }

  getProductDataById(url: string) {
    return this.get(environment.baseUrl + url);
  }

  updateProductDataById(url: string, data: any) {
    return this.put(environment.baseUrl + url, data);
  }
}
